export default __webpack_public_path__ + "static/media/course-content-skipped-pic.2c122288.svg";